import { apiGet } from "@/api/client";

/**
 * 하우스의 시나리오 엔딩 이력.
 * GET /api/v1/public/game/houses/me/scenarios/{scenarioId}/endings
 */
export interface HouseScenarioEndingItem {
    runId: string;
    characterName: string;
    endingId: string;
    outcomeGrade: string;
    finalizedAt: string;
}

export function getHouseScenarioEndings(scenarioId: string): Promise<HouseScenarioEndingItem[]> {
    return apiGet<HouseScenarioEndingItem[]>(
        `/api/v1/public/game/houses/me/scenarios/${encodeURIComponent(scenarioId)}/endings`
    );
}
